/* eslint-disable */

/**
 * Init
 */
const init = () => {

};

export default init;
